//index.js
import App from './App.svelte';

if (!window.blt ) window.blt = {};

let esriPaths = {
    EsriMap: 'esri/Map',
    MapView: 'esri/views/MapView',
    FeatureLayer: 'esri/layers/FeatureLayer',
    Search: 'esri/widgets/Search',
    Basemap: 'esri/Basemap',
    BasemapToggle: 'esri/widgets/BasemapToggle',
    Home: 'esri/widgets/Home',
    Locate: 'esri/widgets/Locate',
    Graphic: 'esri/Graphic',
    Query: 'esri/tasks/support/Query',
    watchUtils: 'esri/core/watchUtils',
    Extent: 'esri/geometry/Extent',
    GeoJSONLayer: 'esri/layers/GeoJSONLayer',
    Collection: 'esri/core/Collection',
    Legend: "esri/widgets/Legend",
    Expand: "esri/widgets/Expand",
    Slider: "esri/widgets/Slider",
    GeometryEngine: "esri/geometry/geometryEngine",
    GeometryEngineAsync: "esri/geometry/geometryEngineAsync",
};

//in dev don't import esri which will result in esri loader being used
import { esri } from 'src/stores.js';

let esriStore = esri.update((esri)=>{esri.paths=esriPaths;return esri});

var app = new App({
	target: document.body
});

export default app;